export const challenges = [
  {
    id: 1,
    type: "body",
    description:
      "Estique um de seus braços com a palma da mão virada para frente e puxe os dedos para cima por 10 segundos por mão.",
    amount: 80,
  },
  {
    id: 2,
    type: "body",
    description:
      "Estique seu braço contra o peito e puxe-o utilizando o outro braço por 10 segundos por braço.",
    amount: 60,
  },
  {
    id: 3,
    type: "body",
    description:
      "Puxe seu pescoço com a ajuda da mão para a direita e para a esquerda, permanecendo na posição por alguns segundos.",
    amount: 70,
  },
  {
    id: 4,
    type: "body",
    description:
      "Com as duas mãos na parte de trás da cabeça, leve-a para baixo, alongando a parte de trás da região.",
    amount: 60,
  },
  {
    id: 5,
    type: "body",
    description:
      "Cruze as pernas e desça com as mãos esticadas em direção ao chão. Repita o movimento com a outra perna na frente.",
    amount: 100,
  },
  {
    id: 6,
    type: "body",
    description:
      "Sentado, abra as pernas e tente encostar as palmas das mãos no chão, repita 3 vezes por 5 segundos.",
    amount: 80,
  },
  {
    id: 7,
    type: "body",
    description:
      "Puxe o joelho de encontro ao peito e segure, troque de perna após 10 segundos.",
    amount: 50,
  },
  {
    id: 8,
    type: "body",
    description:
      "Sentado, cruze uma perna e incline seu tronco à frente, troque de perna após 10 segundos.",
    amount: 80,
  },
  {
    id: 9,
    type: "eye",
    description:
      "Sentado, feche os olhos e cubra-os com as palmas da mão durante 2 minutos, depois abra normalmente.",
    amount: 90,
  },
  {
    id: 10,
    type: "eye",
    description:
      "Em algum ambiente aberto, olhe o mais longe que puder em quatro direções por 3s, mexa apenas os olhos. Repita 3 vezes.",
    amount: 140,
  },
  {
    id: 11,
    type: "eye",
    description:
      "Usando os polegares, massage a área abaixo das sobrancelhas em movimentos circulares por 15 segundos.",
    amount: 70,
  },
  {
    id: 12,
    type: "body",
    description:
      "Em pé, gire a cintura o máximo que puder para a esquerda, segure por cinco segundos. Repita para a direita.",
    amount: 90,
  },
];
